import styled from "styled-components";

export const MainContainer = styled.div`
  position: relative;
  margin-top: 8.75rem;
  margin-right: 2.75rem;
  margin-left: 2.75rem;
  padding-bottom: 8rem;
`;
